import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  voiceExampleBizType: undefined as number | undefined,
};

export const homeSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setVoiceExampleBizType: (state, action: PayloadAction<number | undefined>) => {
      state.voiceExampleBizType = action.payload;
    },
  },
});

export const { setVoiceExampleBizType } = homeSlice.actions;

export default homeSlice.reducer;
